{
  "skip-to-main-content": "Skip to main content",
  "homepage-title": "Book activities and courses",
  "homepage-choose-week": "Choose week",
  "header-membersapp": "Booking portal",
  "home": "Home",
  "activity": "Activity",
  "all": "All",
  "sessions": "Sessions",
  "courses": "Courses",
  "course": "Course",
  "events": "Events",
  "yesterday": "Yesterday",
  "today": "Today",
  "tomorrow": "Tomorrow",
  "nav-booking": "Book",
  "nav-bookings": "Bookings",
  "nav-tickets": "Tickets",
  "nav-account": "Account",
  "desktop-nav-booking": "Book",
  "desktop-nav-bookings": "Bookings",
  "desktop-nav-tickets": "Tickets",
  "desktop-nav-account": "My account",
  "settings-button-aria": "Open settings",
  "book-courses-title": "Book your swim school courses",
  "book-sessions-title": "Book your sessions here",
  "activity-not-bookable": "Not bookable",
  "activity-locked-out": "Locked out",
  "activity-not-bookable-description": "This activity cannot be booked at the moment.",
  "activity-bookable-from": "This activity is bookable from",
  "back-to-home": "Back",
  "book-button": "Book",
  "book-activity": "Book activity",
  "choose-date": "Choose date",
  "to-next-week": "To next week",
  "to-prev-week": "To previous week",
  "place": "Place",
  "places": "places",
  "left": "left",
  "enqueue": "Join queue",
  "booking-reference": "Booking Reference",
  "participants-in-queue": "Participants in queue",
  "participants-booked": "booked",
  "participants-has-booked": "Number of participants booked",
  "in-queue": "{{queue}} in queue",
  "queue": "Queue",
  "queue-position": "Queue position",
  "queue-description": "Note that this is a queue reservation and does not guarantee your spot. If a participant cancels, you'll be able to confirm your spot and make the payment.",
  "full": "Full",
  "choose-occasion": "Choose occasion",
  "occasions": "Occasions",
  "first-occasion": "First occasion",
  "participants": "Participants",
  "participant-already-booked": "Already booked",
  "of": "of",
  "next-session-title": "Next Activity Session",
  "next-session-link": "Navigate to Next Activity Session",
  "next-session-exists": "The next session for this activity this week is",
  "next-session-empty": "This is the last activity session of this activity for the week, navigate to next week and check there.",
  "statistics-label": "Activity",
  "statistics-description": "Number of people at the facility",
  "choose-managed-title": "Choose participant",
  "choose-managed-body": "Select participants for the activity. If you're booking a child or another family member, press \"New user\" to add them to your list.",
  "continue": "Continue",
  "confirm-title": "Confirm booking",
  "slide-confirm": "Slide to confirm",
  "slide-cancel": "Slide to cancel",
  "booking-completed": "Your booking is complete",
  "booking-reserved": "Your booking is reserved",
  "booking-confirmation-message": "Thank you for your booking!",
  "booking-failed": "Booking failed",
  "booking-error-message": "Something went wrong with your booking. Please try again.",
  "booking-full-title": "This activity is fully booked.",
  "booking-full-description": "You can join the waiting list for this activity. If a participant cancels, you may get the spot if you are next in line.",
  "booking-full-queue-description-price": "You have up to 24 hours to make the payment from the moment your queue booking is accepted.",
  "booking-full-queue-description-free": "You will be automatically booked if a spot becomes available, keep an eye on a confirmation email that will be sent to you.",
  "toast-pay-booking": "You haven't paid for your booking yet. Please pay to secure your spot!",
  "toast-pay-within": "You must pay within",
  "toast-pay-now": "Pay now",
  "toast-ticket-activated": "The ticket is now activated",
  "toast-user-created": "The user is now created!",
  "toast-password-changed": "Your password is now changed",
  "toast-user-not-found": "Could not find your user, try logging out and in again and try once more.",
  "toast-ticket-not-found": "Could not find the ticket, please check if the serial number is correct and try again.",
  "toast-ticket-not-activable": "This ticket does not need activation",
  "toast-old-password-incorrect": "The old password is incorrect",
  "toast-passwords-incorrect": "Passwords do not match",
  "toast-error-password-reuse": "You cannot reuse a previous password.",
  "toast-error-password-capital": "You must have at least one uppercase letter in the password",
  "toast-password-changed-successfully": "Password has been changed successfully. You can now log in with your new password.",
  "toast-user-already-booked": "The user is already booked on this activity.",
  "toast-something-error": "Something went wrong, try again later!",
  "toast-used-email": "The email is already registered, try another one.",
  "toast-invalid-ssn": "The social security number is incorrect, check the number of digits and try again.",
  "toast-used-ssn": "The social security number is already registered, if you already have an account, you can log in instead.",
  "toast-used-ssn-managed": "The social security number is already registered.",
  "toast-changed-user": "You have now changed user",
  "toast-changed-photo": "The photo is now changed",
  "toast-photo-upload-error": "Something went wrong, try another photo",
  "toast-changed-info": "User information has been updated",
  "toast-logout-success": "You are now logged out",
  "toast-account-created": "The account is now created!",
  "toast-error-cancellation-time": "The last cancellation time has passed.",
  "toast-error-user-not-found": "Email address not found in the system",
  "toast-error-user-in-queue": "The participant is already in the queue for this activity.",
  "toast-error-user-max-bookings": "The participant has reached the maximum number of bookings.",
  "toast-cancelled-booking": "Your booking has been canceled.",
  "toast-reset-mail-success": "Password reset email has been sent to the email address",
  "toast-navigated-next-date": "Navigated to the occasion",
  "loading-spinner-wait": "Please wait...",
  "no-activities-available": "No classes or courses are currently available",
  "no-sessions-available": "No activities are available on this date.",
  "no-courses-available": "No courses are currently available",
  "no-sessions-available-landing": "No bookable sessions",
  "no-courses-available-landing": "No bookable courses",
  "no-allotments-available": "No events are currently available",
  "no-allotments-available-landing": "No bookable events",
  "no-products-available": "No products are currently available",
  "need-to-login-title": "You need to be logged in",
  "need-to-login-description": "To book classes and courses, you must be logged in.",
  "need-to-login-view-bookings": "You must be logged in to view your bookings",
  "need-to-login-view-tickets": "You must be logged in to view your tickets",
  "to-login-page": "Go to login page",
  "create-account": "Create account",
  "create-account-first-description": "Create an account in your own name. If you are going to book your child into swimming school, you register yourself as the responsible guardian. Once you have logged in and are going to book, you will have the opportunity to specify participants and then enter the child's name and social security number.",
  "create-account-second-title": "Having trouble registering?",
  "create-account-second-description": "If your social security number is already in our customer register (e.g., if you have bought a monthly card from us), you cannot register as a new customer as we require a unique social security number. Contact the swimming hall and we will help you.",
  "forgot-password": "Forgot password",
  "login": "Log In",
  "logout": "Log Out",
  "duration": "Duration",
  "close": "Close",
  "close-dialog": "Close dialog",
  "booking-page-description": "Here you can see all upcoming bookings that have been made. Click on the bookings to see more information about them.",
  "booking-page-your-bookings": "Your Bookings",
  "booking-page-cancellations": "Cancellations",
  "no-bookings-found": "No bookings have been made yet",
  "no-cancellations-found": "No cancellations have been made yet",
  "show-latest-bookings": "Here are your latest bookings",
  "cancel": "Cancel activity",
  "cancelled": "Cancelled",
  "activity-cancelled": "Activity cancelled",
  "cancellation-failed": "Cancellation failed",
  "activity-cancel": "Cancel activity",
  "activity-cancel-description": "You will now cancel the activity. Please note that this action cannot be undone.",
  "activity-review-cancellation": "Confirm cancellation",
  "day": "day",
  "days": "days",
  "hour": "hour",
  "hours": "hours",
  "minute": "minute",
  "minutes": "minutes",
  "statistics-people-title": "Activity",
  "statistics-people-description": "Number of people at the facility",
  "statistics-not-visited": "You haven't visited us yet",
  "statistics-title": "Your visits",
  "statistics-visited-description": "You've visited us the most in these months",
  "latest-notifications": "Latest notifications",
  "see-all": "See All",
  "ticket-page-header": "Tickets",
  "ticket-page-no-tickets": "No tickets found",
  "ticket-page-no-active-tickets": "No active tickets found",
  "ticket-page-read-more": "Click on the ticket you want to scan or learn more about",
  "ticket-page-last-used": "Last used",
  "ticket-page-active": "Valid",
  "ticket-page-not-valid": "Invalid",
  "ticket-page-clips-left": "Clips left",
  "ticket-page-belongs-to": "Belongs to",
  "ticket-valid": "Validity Period",
  "ticket-invalid": "Ticket invalid",
  "ticket-active": "Active",
  "ticket-blocked": "Blocked",
  "ticket-cancelled": "Cancelled",
  "ticket-not-active": "Not active",
  "ticket-not-used": "Not used yet",
  "activate-ticket": "Activate ticket",
  "activate-ticket-description": "If your ticket needs activation, you can do it here. If you bought the ticket at a counter or in the webshop, it is usually activated at the time of purchase.",
  "activate-ticket-number-label": "Serial number",
  "activate-ticket-number-description": "May look like e.g. F3A8014A099133",
  "complete-registration-header": "Complete registration",
  "complete-registration-first-description": "To create your account, you also need a password. You have received an email with a link where you can choose the password.",
  "complete-registration-second-description": "Once you have set a password, you can easily log in and start booking!",
  "complete-registration-shortcuts": "Shortcuts to email pages",
  "customer-info-header": "Customer information",
  "customer-info-title": "Edit customer information",
  "customer-info-description": "Here you can change your information",
  "save-customer-info": "Click 'Save information' when you are finished.",
  "save-customer-info-multi": "Start with selecting a user and click 'Save information' when you are finished.",
  "customer-info-select-user": "Select user",
  "customer-info-base-info": "Basic information",
  "customer-info-firstname": "First name",
  "customer-info-lastname": "Last name",
  "customer-info-email": "Email address",
  "customer-info-civic": "Social security number",
  "customer-info-phone-home": "Phone number (home)",
  "customer-info-phone-mobile": "Phone number",
  "customer-info-phone-work": "Phone number (work)",
  "customer-info-company": "Company",
  "customer-info-phone-error": "Phone number may only contain digits and plus sign",
  "customer-info-address": "Address details",
  "customer-info-address-Generic": "Address",
  "customer-info-address-Delivery": "Delivery Address",
  "customer-info-address-Invoice": "Invoice Address",
  "customer-info-street": "Street",
  "customer-info-street-number": "Number",
  "customer-info-city": "City",
  "customer-info-postal-code": "Postal code",
  "customer-info-postal-code-error": "Must only contain numbers and must be at least five digits",
  "customer-info-country": "Country",
  "customer-info-save": "Save information",
  "required-fields-marked-with": "Required fields marked with",
  "customer-register": "Register",
  "customer-add-user": "Add user",
  "purchase-history-title": "Purchase history",
  "account-logged-out-header": "You are logged out",
  "account-logged-out-description": "Log in to continue. You need an account to use the booking system.",
  "account-bookings-title": "Bookings",
  "account-bookings-description": "View your bookings here",
  "account-tickets-title": "Tickets",
  "account-tickets-description": "View your tickets here",
  "account-purchase-history-title": "Purchase history",
  "account-purchase-history-description": "See your recent purchases",
  "account-subscription-title": "Subscriptions",
  "account-subscription-description": "View your subscriptions",
  "account-subscription-change-card-success": "The payment card has been changed",
  "account-subscription-change-card-error": "Failed to change the payment card, please try again",
  "account-activate-ticket-title": "Activate ticket",
  "account-activate-ticket-description": "Activate your ticket here",
  "account-register-managed-title": "Add user",
  "account-register-managed-description": "Add user here",
  "account-photo-title": "Change photo",
  "account-photo-description": "Change your photo here",
  "account-password-title": "Change password",
  "account-password-description": "Change your password",
  "table-saledate": "Date",
  "table-receipt": "Receipt",
  "table-pos": "Register",
  "table-total-excl-vat": "Total excl. VAT",
  "table-total-incl-vat": "Total",
  "table-price-excl-vat": "Price excl. VAT",
  "table-price-incl-vat": "Price",
  "table-actions": "Actions",
  "table-placeholder": "Filter receipt number",
  "table-columns": "Columns",
  "table-not-found": "No purchases found",
  "table-previous": "Previous",
  "table-next": "Next",
  "table-page": "Page {{pageCount}} of {{maxPageCount}}",
  "table-copy-receipt": "Copy receipt number",
  "table-show-receipt": "Show receipt",
  "table-receipt-description": "Here you can see the details of your purchase.",
  "table-article": "Product",
  "open-menu": "Open menu",
  "search-courses": "Search courses",
  "search-sessions": "Search sessions",
  "show-inactive": "Show inactive",
  "show-full": "Show fully booked",
  "show-full-aria-on": "Hide fully booked",
  "show-full-aria-off": "Show fully booked",
  "show-inactive-aria-on": "Hide inactive",
  "show-inactive-aria-off": "Show inactive",
  "show-cancelled": "Show Cancelled",
  "subscription-header": "My subscriptions",
  "subscription-description": "Below you can see information about your ongoing and completed subscriptions. Click on a subscription for more information and actions.",
  "subscription-status": "Status",
  "subscription-status-aborted": "Cancelled",
  "subscription-status-chargeandfailed": "Charge Failed",
  "subscription-status-chargefailed": "Charge Failed",
  "subscription-status-registered-label": "Registered",
  "subscription-status-registered-successful": "Registration Completed",
  "subscription-status-registered": "Action Required",
  "subscription-status-cancelled": "Cancelled",
  "subscription-status-finalized": "Paid in full",
  "subscription-status-active": "Active",
  "subscription-status-pay": "Payment Required",
  "subscription-status-frozen": "Frozen",
  "subscription-state-aborted-cancelled": "The subscription has been cancelled. You need to order a new subscription to continue using our service.",
  "subscription-state-registered": "This subscription is not active. Click the link below to complete the first payment and activate the subscription.",
  "subscription-state-registeredfinalized": "This subscription is active, and the first payment has been made.",
  "subscription-state-charged": "Payment has been successfully processed, and the subscription is active.",
  "subscription-state-chargedfailed": "Payment failed, likely due to insufficient funds on the payment card or an invalid card. The subscription is not active.",
  "subscription-state-chargedandfailed": "Payment failed. Please contact customer service for assistance.",
  "subscription-state-cancelled": "The subscription has been cancelled. You can still use the subscription for the period you have paid for.",
  "subscription-state-active": "Here you can view information about your subscription and change payment card.",
  "subscription-start-date": "Start date",
  "subscription-end-date": "End date",
  "subscription-type": "Subscription type",
  "subscription-payments-done": "Paid payments",
  "subscription-payments": "Payments",
  "subscription-last-payment": "Last payment",
  "subscription-next-payment": "Next payment",
  "subscription-reference": "Reference",
  "subscription-type-fixed": "Fixed",
  "subscription-type-ongoing": "Ongoing",
  "subscription-pay": "Pay",
  "subscription-cancel": "Cancel subscription",
  "subscription-cancel-confirmation": "To cancel the subscription, please confirm below. This action cannot be undone!",
  "subscription-change-payment": "Change payment card",
  "subscription-cancel-success": "Your subscription is now cancelled",
  "subscription-handle-payment": "Manage payment",
  "subscription-handle-payment-description": "Here you can see payment methods and change payment card",
  "subscription-handle-payment-active": "Active payment card",
  "subscription-handle-payment-change": "Change payment card",
  "subscription-card-number": "Card number",
  "subscription-card-valid-thru": "Expiration date, month/year",
  "subscription-history-charged": "Paid",
  "subscription-history-failed": "Failed charge",
  "subscription-history-due": "Upcoming",
  "subscription-history-cancelled": "Cancelled",
  "subscription-price-per-month": "Price per month",
  "subscription-table-title": "Payment history",
  "subscription-table-payment": "Payment",
  "subscription-table-sum": "Amount",
  "subscription-table-status": "Status",
  "subscription-table-paid": "Paid",
  "confirm": "Confirm",
  "add-new-user": "New user",
  "managed-header": "Add users",
  "managed-description": "Here you can add more people you want to be able to book for, e.g. family members.",
  "managed-description-extra": "If the person is already in our system (through a previous purchase or booking), you cannot add the person here. Please contact staff at your local facility and we will assist you with registration.",
  "managed-add-new": "Add new user",
  "managed-users": "Users",
  "managed-click-user-to-edit": "Click a user to edit their details.",
  "managed-edit-user-for": "Edit details for {{name}}",
  "managed-add-new-user-header": "Add user",
  "managed-add-new-user-description": "Once you have registered, for example, your child, you can book courses and sessions for them.",
  "photo-header": "Photo",
  "photo-description": "Remember that the staff at the facility need to recognize you from the photo.",
  "photo-alt": "Photo of",
  "photo-change": "Change photo",
  "photo-upload-header": "Upload new image",
  "photo-upload-description": "Here you can take a new photo or upload a photo from your device.",
  "photo-change-image": "Select new image",
  "password-header": "Change password",
  "password-header-reset": "Reset Password",
  "password-header-reset-title": "Reset",
  "password-new-description": "Choose a new password for your account. Your password becomes extra secure if it contains both letters and numbers.",
  "password-description": "Here you can change your password. First enter your current password, then your new password.",
  "password-reset-description": "Enter your email address and click send to receive an email with a link to reset your password. Please check your spam folder if you do not receive an email.",
  "password-old": "Current password",
  "password-new": "New password",
  "password-confirm-new": "Confirm new password",
  "password-confirm-change": "Change password",
  "search-close": "Close",
  "search-title": "Search...",
  "search-placeholder": "Courses and weekly activities, name, description, ID...",
  "search-no-results": "No results found",
  "badge-not-paid": "Not paid",
  "badge-queue": "In queue",
  "badge-cancelled": "Cancelled",
  "badge-paid": "Paid",
  "dark-theme": "Dark theme",
  "language-change": "Change language",
  "language-change-to": "Change language to",
  "language-swedish": "Swedish",
  "language-english": "English",
  "language-danish": "Danish",
  "language-german": "German",
  "language-spanish": "Spanish",
  "payment": "Payment",
  "install-app-maybe-later": "Maybe later",
  "install-app-dont-show-again": "Don't show again",
  "install-app-install": "Install",
  "install-app-our": "Install our app",
  "install-app-description": "For the best experience, it is recommended to install the app. Press the button to install.",
  "install-app-description-ios": "Install our app by pressing",
  "install-app-description-ios-update": "Update our app by pressing",
  "install-app-description-update": "Thank you for updating the app! Press the button and get started with booking again. The old app on the home screen can then be removed.",
  "install-app-confirmation-title": "Are you sure?",
  "install-app-confirmation-description": "You will not receive a reminder to install our app again. If you change your mind, you can press",
  "install-app-confirmation-continue": "and then \"Install the app\".",
  "install-app-confirmation-continue-firefox": "and then \"Install\".",
  "install-app-confirmation-samsung-continue-1": "and then",
  "install-app-confirmation-samsung-continue-2": "\"Add to home screen\" and then press \"Home screen\".",
  "install-app-confirmation-safari-continue-1": "and then scroll and press:",
  "install-app-confirmation-safari-continue-2": "Add to home screen",
  "install-app-samsung-warning-title": "For you with Samsung Browser",
  "install-app-samsung-warning-description": "Android treats all web apps installed with Samsung Browser as insecure. Choose to install anyway or switch browser to install.",
  "form-error-firstname": "First name is required",
  "form-error-firstname-long": "First name must not exceed 100 characters",
  "form-error-lastname": "Last name is required",
  "form-error-lastname-long": "Last name must not exceed 100 characters.",
  "form-error-mail": "Email is required",
  "form-error-mail-invalid": "Invalid email address",
  "form-error-civic-short": "Social security number must contain at least 10 digits",
  "form-error-civic-invalid": "Invalid social security number",
  "form-error-zip": "Zip code is required",
  "form-error-zip-invalid": "Invalid zip code",
  "form-error-password-short": "Password must be at least 5 characters",
  "form-error-password-long": "Password must not exceed 100 characters",
  "form-error-phone": "Phone number is required",
  "form-error-phone-invalid": "Phone number must be between 10-15 numbers",
  "form-error-email-invalid": "Invalid email address",
  "form-error-email-long": "Email address must not exceed 255 characters",
  "form-error-phone-long": "Phone number must not exceed 20 characters",
  "form-error-street-long": "Street address must not exceed 255 characters",
  "form-error-street-number-long": "Street number must not exceed 10 characters",
  "form-error-city-long": "City must not exceed 100 characters",
  "form-error-country-long": "Country must not exceed 100 characters",
  "form-error-photo-required": "Photo is required",
  "form-error-field-required": "{{field}} is required",
  "form-error-field-invalid": "Invalid {{field}}",
  "form-show-old-password": "Show your old password on the screen",
  "form-hide-old-password": "Hide your old password on the screen",
  "form-show-password": "Show your new password on the screen",
  "form-hide-password": "Hide your new password on the screen",
  "form-show-verification-password": "Show your new verification password on the screen",
  "form-hide-verification-password": "Hide your new verification password on the screen",
  "form-phone-short": "The phone number is too short",
  "form-phone-long": "The phone number is too long",
  "form-phone-invalid": "Use only numbers for the phone number",
  "cookies-title": "Cookies",
  "cookies-description": "We use necessary cookies on the site to ensure it operates as intended and provides you with the best experience.",
  "cookies-link": "Read more about our cookies",
  "cookies-consent-ok": "OK",
  "cookies-consent-decline": "Decline",
  "not-found-title": "Lost Link",
  "not-found-description": "It seems like the link you are trying to reach is lost. Click the button to return to the homepage.",
  "not-found-button": "To the Homepage",
  "not-found-eyebrow": "Error · Page not found",
  "not-found-heading": "This page wandered off",
  "not-found-body": "It may have been moved, renamed, or never existed at all. Either way, we've got an eye on it.",
  "not-found-back-home": "Back to home",
  "not-found-go-back": "Go back",
  "not-found-heading-course": "We couldn't find that course",
  "not-found-body-course": "The course may have been removed, or the link is wrong. Try browsing our courses instead.",
  "not-found-heading-session": "We couldn't find that session",
  "not-found-body-session": "The session may have been removed, or the link is wrong. Try browsing our sessions instead.",
  "not-found-heading-allotment": "We couldn't find that event",
  "not-found-body-allotment": "The event may have been removed, or the link is wrong. Try browsing our events instead.",
  "not-found-heading-product": "We couldn't find that ticket",
  "not-found-body-product": "The ticket may have been removed or sold out, or the link is wrong. Try browsing our tickets instead.",
  "not-found-heading-articlegroup": "We couldn't find that category",
  "not-found-body-articlegroup": "The category may have been removed or renamed, or the link is wrong.",
  "accessibility-title": "Accessibility",
  "offline-title": "Offline",
  "filter-title": "Filter",
  "sorting-facility-title": "Facility",
  "sorting-tag-title": "Tag",
  "sorting-showing-facilities": "{{count}} facilities selected",
  "sorting-showing-tags": "{{count}} tags selected",
  "update": "Update",
  "update-title": "Update our app",
  "update-description": "Our app has been updated and you would need to reinstall it. Press the button below to copy the link. Then open the link in your regular web browser and install the app.",
  "update-copy": "Copy installation link",
  "update-copied": "Copied the link",
  "update-finished": "When the installation is finished, you can continue here in the browser or open the app.",
  "course-detail-title": "{{courseName}} course information",
  "course-detail-description": "Here you can see information about the course {{courseName}}, dates and times, and book yourself in.",
  "session-detail-title": "{{sessionName}} session information",
  "session-detail-description": "Here you can see information about the session {{sessionName}}, date and time, and book yourself in.",
  "allotment-detail-title": "{{allotmentName}} activity information",
  "allotment-detail-description": "Here you can see information about the activity {{allotmentName}}, date and time, and sign up.",
  "allotments": "Events",
  "products": "Tickets",
  "ticket": "Ticket",
  "product": "Product",
  "overview": "Overview",
  "description": "Description",
  "session-information": "Activity information",
  "course-information": "Course information",
  "bookable-from": "Bookable from",
  "number-of-occasions": "Number of occasions",
  "number-of-places": "Number of places",
  "number-of-booked": "Number booked",
  "course-id": "Course ID",
  "instructor": "Instructor",
  "contact": "Contact",
  "length": "Length",
  "choose-participant": "Choose participant",
  "create-new": "Create new",
  "participant": "Participant",
  "price-group": "Price group",
  "base": "Base",
  "price-includes": "Price includes VAT and fees.",
  "book": "Book",
  "book-course": "Book course",
  "book-session": "Book session",
  "book-allotment": "Book activity",
  "login-to-book": "Log in to book",
  "persons": "people",
  "time": "Time",
  "add-to-cart": "Add to cart",
  "cart": "Cart",
  "cart-empty": "Your cart is empty",
  "cart-total": "Total",
  "cart-checkout": "Checkout",
  "cart-continue-shopping": "Continue shopping",
  "cart-open": "Open cart",
  "cart-close": "Close cart",
  "cart-decrease-quantity": "Decrease quantity by 1",
  "cart-increase-quantity": "Increase quantity by 1",
  "cart-remove-item": "Remove",
  "categories": "Categories",
  "article-groups": "Other",
  "our-activities": "Our Activities",
  "our-activities-description": "Here are our upcoming activities, you can also choose to view all activities.",
  "quantity": "Quantity",
  "product-detail-title": "{{productName}} product information",
  "product-detail-description": "Here you can see information about the product {{productName}}",
  "no-description-available": "No description available",
  "multi-ticket": "Family ticket",
  "form-personal-info": "Personal Information",
  "form-personal-info-description": "Please fill in the information below to continue",
  "form-firstname": "First Name",
  "form-lastname": "Last Name",
  "form-email": "Email Address",
  "form-civic": "YYYYMMDD-NNNN",
  "form-phone": "Phone Number",
  "form-address": "Address",
  "form-street": "Street",
  "form-street-number": "Street number",
  "form-zip-code": "Zip Code",
  "form-city": "City",
  "form-country": "Country",
  "form-photo": "Photo",
  "form-photo-exceed-size": "Photo exceeds maximum size",
  "form-photo-exceed-size-max-files": "You can only upload a maximum of {{maxFiles}} files.",
  "form-invalid-file-type": "The file type {{fileType}} is not accepted.",
  "upload-file": "Upload file",
  "uploaded-image": "Uploaded image",
  "drop-image-or-browse": "Drop your image here or click to browse",
  "max-size": "Max size: {{size}}MB",
  "remove-image": "Remove image",
  "crop": "Crop",
  "crop-close": "Discard",
  "crop-error": "Something went wrong when cropping!",
  "profile-image": "Profile image",
  "image-cropper-alt": "Image cropper",
  "loading": "Loading...",
  "settings": "Settings",
  "settings-description": "Change your language, currency and theme",
  "language": "Language",
  "currency": "Currency",
  "theme": "Theme",
  "change-language": "Change language",
  "change-language-to": "Change language to",
  "choose-theme": "Choose a theme",
  "theme-light": "Light",
  "theme-dark": "Dark",
  "theme-system": "System",
  "close-settings": "Close settings",
  "current-language": "Current language",
  "flag": "flag",
  "out-of-stock": "Out of stock",
  "product-type": "Product Type",
  "regular-products": "Regular Products",
  "gift-certificate": "Gift Certificate",
  "gift-certificates": "Gift Certificates",
  "multi-tickets": "Multi Tickets",
  "packages": "Packages",
  "personal-tickets": "Personal Tickets",
  "personal-ticket-fill-out-fields": "Fill in the details for the person who will use the ticket",
  "category": "Category",
  "sizes": "Sizes",
  "no-products-found": "No products match the selected filters.",
  "results": "results",
  "filters": "Filters",
  "search-products": "Search products...",
  "clear-search": "Clear search field",
  "sort-by": "Sort by",
  "name-ascending": "Name A-Z",
  "name-descending": "Name Z-A",
  "price-ascending": "Lowest price",
  "price-descending": "Highest price",
  "search-label": "Search",
  "search-allotments": "Search allotments...",
  "location": "Location",
  "all-locations": "All locations",
  "date-range": "From and to date",
  "no-allotments-found": "No allotments found",
  "time-ascending": "Time (ascending)",
  "time-descending": "Time (descending)",
  "date-not-available": "Date not available",
  "go-to-prev-month": "Go to previous month {{monthName}}",
  "go-to-next-month": "Go to next month {{monthName}}",
  "go-to-prev-week": "Go to previous week {{previousWeek}}",
  "go-to-next-week": "Go to next week {{nextWeek}}",
  "select-date": "Select date",
  "select-tickets": "Select tickets",
  "exceeds-capacity": "Exceeds capacity",
  "spots-remaining": "spots remaining",
  "pick-date": "Pick date",
  "allotment-information": "Allotment information",
  "allotment-id": "Allotment ID",
  "available-courses": "Available courses",
  "available-sessions": "Available sessions",
  "available-occasions": "Available occasions",
  "places-remaining": "Places remaining",
  "date": "Date",
  "change-card-view-to": "Switch to {{cardViewType}}",
  "grid-view": "grid view",
  "list-view": "list view",
  "abort": "Cancel",
  "invalid-additional-field": "Invalid format for {{fieldName}}",
  "select-tickets-per-category": "Select number of tickets per category",
  "free-of-charge": "Free",
  "places-left": "{{count}} places left",
  "enter-additional-information": "Enter additional information",
  "enter-field": "Enter {{field}}",
  "could-not-find-activity": "Could not find activity",
  "could-not-find-product": "Could not find product",
  "move-occasions-title": "Reschedule tickets",
  "move-occasions-back-to-bookings": "Back to my bookings",
  "move-occasions-step-of": "Step {{current}} of {{total}} — {{label}}",
  "move-occasions-step-intro": "Introduction",
  "move-occasions-step-booking": "Choose booking",
  "move-occasions-step-datetime": "Date & time",
  "move-occasions-step-confirm": "Confirm",
  "move-occasions-step-code": "Code",
  "move-occasions-step-done": "Done",
  "move-occasions-choose-title": "Choose booking to reschedule",
  "move-occasions-choose-subtitle": "We found the following bookings on your account.",
  "move-occasions-datetime-title": "Choose a new date and time",
  "move-occasions-choose-time": "Choose time",
  "move-occasions-time-helper": "Struck-through times are fully booked.",
  "move-occasions-confirm-title": "Confirm your reschedule",
  "move-occasions-confirm-helper": "Please check the details before confirming.",
  "move-occasions-label-activity": "Activity",
  "move-occasions-label-current": "Original booking",
  "move-occasions-label-new": "Rescheduled to",
  "move-occasions-label-quantity": "Number of tickets",
  "move-occasions-otp-title": "Confirm with PIN code",
  "move-occasions-otp-subtitle": "Enter your four-digit code to confirm the reschedule. The PIN code is in the booking confirmation email.",
  "move-occasions-otp-label": "Four-digit confirmation code",
  "move-occasions-success-title": "Your reschedule is complete",
  "move-occasions-success-summary": "{{title}} is now rescheduled to {{dateTime}}, {{qty}} {{unit}}.",
  "move-occasions-next": "Next",
  "move-occasions-back": "Back",
  "move-occasions-continue": "Continue",
  "move-occasions-submit": "Confirm reschedule",
  "move-occasions-to-bookings": "Back to the booking page",
  "move-occasions-ticket": "ticket",
  "move-occasions-tickets": "tickets",
  "move-occasions-loading": "Loading…",
  "move-occasions-no-bookings": "No reschedulable bookings were found.",
  "move-occasions-error-missing-token": "Couldn't find the booking. Copy the full link from the confirmation email and try again.",
  "move-occasions-error-bad-token": "Couldn't find the tickets. Try copying the full link from the confirmation email and try again.",
  "move-occasions-error-illegal-pin": "Wrong PIN code, enter the correct code and try again",
  "move-occasions-error-no-occasions": "No occasions to move from",
  "move-occasions-error-too-close": "You've chosen an occasion too close in time to the original occasion. Choose a later date and try again.",
  "move-occasions-error-invalid-parameter": "Something went wrong. Reload the page and try again.",
  "move-occasions-error-api": "Something went wrong. Reload the page and try again.",
  "cookies-policy-title": "Cookie policy",
  "cookies-what-are-cookies": "What are cookies?",
  "cookies-what-are-cookies-description": "Cookies are text files that are stored in your web browser when you visit the website. Cookies are used to improve the use of this website, for example: to keep you signed in to your account, add items to your shopping cart, or change the language preferences. ",
  "cookies-manage-cookies-in-your-browser": "Managing cookies",
  "cookies-manage-cookies-in-your-browser-description": "If you don’t accept the use of cookies, the function can be turned off in your browser’s settings. This may however lead to the website not functioning properly.",
  "cookies-our-cookies": "What types of cookies do we use?",
  "cookies-our-cookies-description": "There are different types of cookies, but this website only uses essential cookies. These cookies do not require your consent but are necessary for the website to function.",
  "cookies-names": "Name",
  "cookies-purpose": "Purpose",
  "cookies-storage-time": "Storage time",
  "cookies-save-your-culture": "Saves your choice of language and regional setting (e.g. sv-SE).",
  "cookies-session-or-until-you-change-language": "Session or until you change language",
  "cookies-language-setting-used-by-translation-system": "Language setting used by translation system, synced with",
  "cookies-language-setting-used-by-translation-system-description": "Language setting used by translation system, synced with",
  "cookies-save-currency": "Saves the currency prices are displayed in.",
  "cookies-save-currency-description": "Session or until you change currency",
  "cookies-save-saleid": "Links your browser to the ongoing cart/booking so that products and tickets remain between page views.",
  "cookies-save-saleid-description": "Session (deleted when the purchase is completed or the cart is cleared)",
  "cookies-save-membersapp-consent": "Remembers that you have accepted the information about cookies in the banner at the bottom of the page.",
  "cookies-one-year": "1 year",
  "cookies-save-membersapp-theme": "Saves your choice of light, dark or system theme."
}
